import { useEffect } from 'react'

const APP_SCROLL_SELECTOR = '[data-app-scroll]'

let lockCount = 0
let lockedElement: HTMLElement | null = null
let previousOverflow = ''

function getScrollContainer(): HTMLElement {
  return document.querySelector<HTMLElement>(APP_SCROLL_SELECTOR) ?? document.documentElement
}

export function lockScroll(): void {
  if (lockCount === 0) {
    lockedElement = getScrollContainer()
    previousOverflow = lockedElement.style.overflow
    lockedElement.style.overflow = 'hidden'
  }
  lockCount += 1
}

export function unlockScroll(): void {
  if (lockCount === 0) return
  lockCount -= 1
  if (lockCount === 0 && lockedElement) {
    lockedElement.style.overflow = previousOverflow
    lockedElement = null
    previousOverflow = ''
  }
}

/** テスト用: モジュール状態をリセット */
export function resetScrollLockForTests(): void {
  if (lockedElement) {
    lockedElement.style.overflow = previousOverflow
  }
  lockCount = 0
  lockedElement = null
  previousOverflow = ''
}

/** テスト用: 現在のロック参照数 */
export function getScrollLockCountForTests(): number {
  return lockCount
}

/**
 * モーダル表示中に AppShell の main（または documentElement）のスクロールを止める。
 * ネストしたモーダルは参照カウントで安全に unlock する。
 */
export function useScrollLock(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return
    lockScroll()
    return () => unlockScroll()
  }, [enabled])
}
